import script from "./FirstAccessView.vue?vue&type=script&setup=true&lang=js"
export * from "./FirstAccessView.vue?vue&type=script&setup=true&lang=js"

import "./FirstAccessView.vue?vue&type=style&index=0&id=73871624&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73871624"]])

export default __exports__